import React, { useState } from 'react';
import { HashRouter as Router, Link, useLocation } from 'react-router-dom';
import { RouteWithSubRoutes } from '../../service/common';

function SidebarGroup({ title, routes, defaultExpanded = false }) {
  const location = useLocation();
  const isActiveGroup = routes.some(r => location.pathname === r.path || location.pathname.startsWith(r.path + '/'));
  const [expanded, setExpanded] = useState(defaultExpanded || isActiveGroup);

  const isOpen = expanded;

  if (routes.length === 0) return null;

  return (
    <div style={{ marginBottom: '2px' }}>
      <div
        onClick={() => setExpanded(prev => !prev)}
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: '10px 16px',
          cursor: 'pointer',
          color: '#3c4858',
          fontSize: '13px',
          fontWeight: '600',
          userSelect: 'none',
          transition: 'background-color 0.15s ease',
        }}
        onMouseEnter={e => e.currentTarget.style.backgroundColor = '#f5f7fa'}
        onMouseLeave={e => e.currentTarget.style.backgroundColor = 'transparent'}
      >
        <span>{title}</span>
        <i
          className={isOpen ? 'fa fa-chevron-down' : 'fa fa-chevron-right'}
          style={{ fontSize: '10px', color: '#8492a6', transition: 'transform 0.2s ease' }}
        />
      </div>
      {isOpen && (
        <ul className='sidebar-menu' style={{ marginBottom: '4px' }}>
          {routes.map(route => {
            const isActive = location.pathname === route.path || location.pathname.startsWith(route.path + '/');
            return (
              <li key={route.path} style={{ border: 'none' }}>
                <Link to={route.path} className='sidebar-link' style={{
                  display: 'flex',
                  alignItems: 'center',
                  padding: '8px 16px',
                  color: isActive ? '#3366FF' : '#3c4858',
                  textDecoration: 'none',
                  gap: '10px',
                  borderRadius: '8px',
                  margin: '1px 8px',
                  transition: 'background-color 0.15s ease',
                  fontSize: '14px',
                  fontWeight: isActive ? '500' : '400',
                  backgroundColor: isActive ? '#eef2ff' : 'transparent',
                }}>
                  <i className={route.cssClass || 'fa fa-th-large'} style={{
                    fontSize: '15px',
                    width: '20px',
                    textAlign: 'center',
                    color: isActive ? '#3366FF' : '#8492a6'
                  }} />
                  <span>{route.name}</span>
                </Link>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
}

export default function LeftNav({ routes = [] }) {
  const firstRoute = routes.length > 0 ? routes[0].path : '/login';

  const administrationRoutes = routes.filter(r => !r.displayNone && r.category === 'Administration');
  const libraryRoutes = routes.filter(r => !r.displayNone && !r.isApp && !['User Management', 'Users', 'Roles', 'Administration', 'QA'].includes(r.category));
  const appRoutes = routes.filter(r => !r.displayNone && r.isApp);
  const userManagementRoutes = routes.filter(r => !r.displayNone && ['User Management', 'Users', 'Roles'].includes(r.category));
  const qaRoutes = routes.filter(r => !r.displayNone && r.category === 'QA');

  return (
    <Router>
      <aside className='main-sidebar' style={{
        backgroundColor: '#ffffff',
        borderRight: '1px solid #e8ecf1'
      }}>
        <SidebarGroup title='Library' routes={libraryRoutes} defaultExpanded={true} />
        <SidebarGroup title='App' routes={appRoutes} />
        <SidebarGroup title='QA' routes={qaRoutes} />
        <SidebarGroup title='User Management' routes={userManagementRoutes} />
        <SidebarGroup title='Administration' routes={administrationRoutes} />
      </aside>
      <div className='content-wrapper' style={{ paddingTop: '20px' }}>
        {routes.map((route) => RouteWithSubRoutes(route, firstRoute))}
      </div>
    </Router>
  );
}
